module.exports = __webpack_public_path__ + "static/media/bgi_talentx_app@2x.a3ab4262.jpg";